<section
  class="video-room"
  [class.video-room--expanded]="isExpanded"
  [class.video-room--controls-hidden]="!controlsVisible"
  role="region"
  aria-label="Sala de videollamada"
  (mousemove)="showControlsTemporarily()"
  (touchstart)="showControlsTemporarily()">
  <div class="video-room__header">
    <div>
      <span class="video-pill">Mindhelp</span>
      <h1>Sesión en videollamada</h1>
    </div>
  </div>

  <main class="video-stage" *ngIf="session; else connecting">
    <section class="remote-grid" [ngClass]="{
      'remote-grid--empty': streams.length === 0,
      'remote-grid--single': streams.length === 1,
      'remote-grid--double': streams.length === 2,
      'remote-grid--multi': streams.length > 2
    }">
      <div class="waiting-panel" *ngIf="streams.length === 0 && !hasRemoteConnection">
        <span class="waiting-pulse"></span>
        <h2>Esperando al terapeuta</h2>
        <p>Tu sala ya está lista. Cuando el terapeuta entre, su video aparecerá aquí automáticamente.</p>
      </div>

      <div class="connected-panel" *ngIf="streams.length === 0 && hasRemoteConnection">
        <div class="connected-avatar">
          <mat-icon>person</mat-icon>
        </div>
        <h2>Terapeuta conectado</h2>
        <p>La llamada ya está activa. Si el terapeuta tiene la cámara apagada, seguiremos mostrando este avatar.</p>
      </div>

      <app-subscriber
        class="remote-tile"
        *ngFor="let stream of streams"
        [stream]="stream"
        [session]="session">
      </app-subscriber>
    </section>

    <aside class="local-preview">
      <div class="local-preview__label">Tu cámara</div>
      <app-publisher [session]="session"></app-publisher>
    </aside>
  </main>

  <ng-template #connecting>
    <main class="video-stage">
      <section class="remote-grid remote-grid--empty">
        <div class="waiting-panel waiting-panel--loading">
          <span class="waiting-pulse"></span>
          <h2>Preparando la videollamada...</h2>
          <p>Estamos conectando tu sesión de Mindhelp. En cuanto esté lista, aparecerá tu cámara en esta misma vista.</p>
        </div>
      </section>
    </main>
  </ng-template>

  <section class="call-controls">
    <button
      class="call-button call-button--secondary"
      (click)="toggleExpanded()"
      type="button"
      [attr.aria-label]="isExpanded ? 'Salir de pantalla completa' : 'Agrandar videollamada'"
      [title]="isExpanded ? 'Salir de pantalla completa' : 'Agrandar videollamada'">
      <mat-icon *ngIf="!isExpanded">open_in_full</mat-icon>
      <mat-icon *ngIf="isExpanded">close_fullscreen</mat-icon>
    </button>
    <button
      class="call-button"
      [class.call-button--off]="!video.video"
      [disabled]="!session"
      (click)="videoSettings('video')"
      type="button"
      [attr.aria-label]="video.video ? 'Apagar cámara' : 'Encender cámara'"
      [title]="video.video ? 'Apagar cámara' : 'Encender cámara'">
      <mat-icon *ngIf="!video.video">videocam_off</mat-icon>
      <mat-icon *ngIf="video.video">videocam</mat-icon>
    </button>
    <button
      class="call-button"
      [class.call-button--off]="!video.audio"
      [disabled]="!session"
      (click)="videoSettings('mic')"
      type="button"
      [attr.aria-label]="video.audio ? 'Apagar micrófono' : 'Encender micrófono'"
      [title]="video.audio ? 'Apagar micrófono' : 'Encender micrófono'">
      <mat-icon *ngIf="!video.audio">mic_off</mat-icon>
      <mat-icon *ngIf="video.audio">mic</mat-icon>
    </button>
    <button
      class="call-button call-button--danger"
      (click)="endCall()"
      type="button"
      aria-label="Salir de la videollamada"
      title="Salir de la videollamada">
      <mat-icon>logout</mat-icon>
    </button>
  </section>
</section>
